<template>
  <div>
    <div class="wrap reservation-coaching-wrap">
      <div class="top-header">
        <h3>나의 코칭</h3>
      </div>
      <div class="body-wrap">
        <incMenu></incMenu>
        <div v-if="!list.length" class="mt-20">
          <p class="txt-center">완료된 코칭이 없습니다</p>
        </div>
        <div class="reservation-list w-90per mg-auto" v-else>
          <ul>
            <li class="clear" @click="view(item.sessionIdx)" v-for="(item, index) in list" :key="index">
              <div class="float-left coach-img" style="width: 76px; height: 82px">
                <img :src="item.coarPic" style="width: 100%" />
              </div>
              <div class="float-left coach-info">
                <span class="unwritten" v-if="item.reflectionNoteYn == 'Y1' && item.reflectidx == null">성찰 노트 미작성</span>
                <h1>{{ item.coachName }} <b>코치</b></h1>
                <p>{{ item.startDate }}({{ item.day }}) {{ item.start_time }} ~ {{ item.end_time }}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="bnb-btn" v-if="isEmbedded">
          <button @click="viewSurvey()">나의 관심사 리포트 확인하기</button>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incMenu from "@/components/inc/inc_menu.vue";
import incTab from "@/components/inc/inc_tab.vue";
import dayjs from "dayjs";
export default {
  name: "complate_coaching",
  data: () => ({
    list: [],
    weekday: ["일", "월", "화", "수", "목", "금", "토"],
    isEmbedded: true,
    detailList: "",
  }),
  components: {
    incTab,
    incMenu,
  },
  mounted() {
    if (this.$store.state.userInfo.courseEmbeddedSurvey == "Y") {
      this.isEmbedded = true;
    } else {
      this.isEmbedded = false;
    }
    this.getComplateCoarching();
    this.detailList = setInterval(() => {
      this.getComplateCoarching();
    }, 2000);
  },
  methods: {
    getComplateCoarching() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/front/coarching/complete/list", { params })
        .then((res) => {
          console.log(res);
          if (res.data.success) {
            this.list = res.data.data;
            for (let item of this.list) {
              item.start_time = dayjs(item.startDatetime).format("HH:mm");
              item.end_time = dayjs(item.endDatetime).format("HH:mm");
              let time_value = {
                start_time: item.start_time,
                end_time: item.end_time,
              };
              this.$store.commit("setCoachingTime", time_value);
              item.time = this.$store.state.coachingTime;

              item.startDate = dayjs(item.startDatetime).format("YYYY.MM.DD");
              this.$store.commit("setCoachingDays", dayjs(item.startDatetime).day());
              item.day = this.$store.state.coachingDays;
            }
            console.log(this.list);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewSurvey() {
      this.$router.push({ name: "embedded_survey_result", params: { view: 1 } });
    },
    view(sessionIdx) {
      this.$router.push({ name: "coaching_finish", params: { sessionIdx: Number(sessionIdx) } });
    },
  },
  destroyed() {
    clearInterval(this.detailList);
  },
};
</script>
